import { programSlices } from "./programSlices";
import { clearSuggestions } from "./requirementSuggestions";
import { clearPoolSuggestions } from "./poolSuggestions";
import { clearUserItemCache } from "./userCourseCache";

/**
 * 编排器缓存含 userState(guest = 零完成初始态),身份切换(换账号/登入登出)
 * 时整体清掉防串号。Home / Program / Requirement 页共用,模块级单例与
 * programSlices 同生命周期。suggestions 缓存的排除口径随用户变,一并清;
 * 用户课程条目缓存(userCourseCache)同理。
 */
let identity: string | null = null;

export function ensureSliceCacheIdentity(next: string): void {
    if (identity !== null && identity !== next) {
        programSlices.clearAll();
        clearSuggestions();
        clearPoolSuggestions();
        clearUserItemCache();
    }
    identity = next;
}
